import React from "react";
import { Form, InputNumber } from "antd";

export default function MainFeaturesSection() {
  return (
    <>
      <Form.Item label="Сарын хүү (%)">
        <div style={{ display: "flex", gap: 8 }}>
          <Form.Item name="minMonthlyInterestRate" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.01}
              placeholder="Хамгийн бага"
            />
          </Form.Item>
          <span style={{ lineHeight: "32px", color: "#999" }}>–</span>
          <Form.Item name="maxMonthlyInterestRate" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.01}
              placeholder="Хамгийн их"
            />
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item label="Жилийн хүү (%)">
        <div style={{ display: "flex", gap: 8 }}>
          <Form.Item name="minAnnualInterestRate" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.01}
              placeholder="Хамгийн бага"
            />
          </Form.Item>
          <span style={{ lineHeight: "32px", color: "#999" }}>–</span>
          <Form.Item name="maxAnnualInterestRate" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.01}
              placeholder="Хамгийн их"
            />
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item name="minBalance" label="Доод үлдэгдэл (₮)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          parser={(v) => v.replace(/,/g, "")}
          placeholder="10,000"
        />
      </Form.Item>

      <Form.Item label="Хугацаа (сар)">
        <div style={{ display: "flex", gap: 8 }}>
          <Form.Item name="minDurationMonths" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={1}
              placeholder="Хамгийн бага"
            />
          </Form.Item>
          <span style={{ lineHeight: "32px", color: "#999" }}>–</span>
          <Form.Item name="maxDurationMonths" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={1}
              placeholder="Хамгийн их"
            />
          </Form.Item>
        </div>
      </Form.Item>
    </>
  );
}
